module.exports = __webpack_public_path__ + "static/media/trip-image-3.5f932f02.png";